import React, { Suspense, lazy } from 'react'
import { Link } from 'react-router-dom'
import { Row, Button, Container, Col } from 'reactstrap'
import AccordionItem from '../../../components/Plans/Sidebar/AccordionItem'
import PlanFilters from './PlanFilters'

import CartIcon from '../../../assets/img/icons/SHOPPING.svg'
import FavouriteIcon from '../../../assets/img/icons/ADD TO FAV.svg'
import './PlanSidebar.css'
import { useSelector } from 'react-redux'

const UserProfile = lazy(() => import('../userProfile/UserProfile'))

const Loading = () => {
    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                fontSize: '16px',
                fontWeight: 'bold',
                padding: '20px 0',
                color: '#8e8e8e',
            }}
        >
            در حال بارگذاری ...
        </div>
    )
}

const PlanSidebar = ({ isCustomProfile, ...props }) => {
    const cart = useSelector((state) => state.payment.cart)
    const profileLoading = useSelector((state) => state.user.profileLoading)
    const planProfileLoading = useSelector(
        (state) => state.user.planProfileLoading
    )

    return (
        <Container
            className="plan-sidebar h-100 p-0"
            style={{ backgroundColor: '#eeeeee' }}
        >
            {profileLoading || planProfileLoading ? (
                <Loading />
            ) : (
                <>
                    <Row className="plan-sidebar__row">
                        <Col className="p-0">
                            <Suspense fallback={<Loading />}>
                                <UserProfile
                                    isCustomProfile={isCustomProfile}
                                />
                                <AccordionItem
                                    title="سبد خرید"
                                    icon={CartIcon}
                                    badge={cart.length}
                                    to="/cart"
                                />
                                <AccordionItem
                                    title="لیست علاقه‌مندی‌ها"
                                    icon={FavouriteIcon}
                                    className="bt"
                                    to="/?type=favourite"
                                />
                                <div className="plan-sidebar__action">
                                    <Link to={'/app'}>
                                        <Button>ایجاد طرح جدید</Button>
                                    </Link>
                                </div>
                            </Suspense>
                        </Col>
                    </Row>
                    <Row className="plan-sidebar__row">
                        <Col className="p-0">
                            <Suspense fallback={<Loading />}>
                                {!isCustomProfile && <PlanFilters />}
                            </Suspense>
                        </Col>
                    </Row>
                </>
            )}
        </Container>
    )
}

export default PlanSidebar
